import React, { useState } from "react";
import Footer from "./Footer";

type Props = {
  startQuiz: (questions: string) => void;
};

const Intro = ({ startQuiz }: Props) => {
  const [selectedOption, setSelectedOption] = useState("10");

  const handleOptionChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="container text-center">
      <div className="display-3 text-center mt-3">
        Challenge Your C++ Skills
      </div>
      <div className="display-6 text-center mt-3 mb-5">
        The quiz has over 200 questions across all C++ topics.
      </div>

      <div className="container mt-5">
        <h3>Choose your quiz size:</h3>
        <div className="btn-group btn-group-toggle mt-3" data-toggle="buttons">
          <label className="btn btn-secondary">
            <input
              type="radio"
              name="options"
              id="option1"
              value="5"
              checked={selectedOption === "5"}
              onChange={handleOptionChange}
              autoComplete="off"
            />{" "}
            5 questions
          </label>
          <label className="btn btn-secondary">
            <input
              type="radio"
              name="options"
              id="option2"
              value="10"
              checked={selectedOption === "10"}
              onChange={handleOptionChange}
              autoComplete="off"
            />{" "}
            10 questions
          </label>
          <label className="btn btn-secondary">
            <input
              type="radio"
              name="options"
              id="option3"
              value="15"
              checked={selectedOption === "15"}
              onChange={handleOptionChange}
              autoComplete="off"
            />{" "}
            15 questions
          </label>
        </div>
      </div>

      <div className="mt-5 col-auto ">
        <button
          type="submit"
          className="btn btn-lg btn-primary"
          onClick={() => startQuiz(selectedOption)}
        >
          TAKE QUIZ
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default Intro;
